import * as yup from "yup";
import { isDateGreaterOrEqualToday } from "../helpers/isDateGreaterOrEqualToday";
const today = new Date().toISOString().split("T")[0];
const urlRegex =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
// const { id } = useParams(); 

export const formSchema: { [key: string]: yup.AnySchema } = {

  "/admin/login": yup.object({
    username: yup
      .string()
      .required("Username is required")
      .trim()
      .min(3, "Username must be atleast 3 characters long")
      .max(50, "Username must not exceed 50 characters"),

    password: yup
      .string()
      .required("Password is required")
      // .min(8, "Password must be atleast 8 characters long")
      .max(50, "Password must not exceed 50 characters"),
    // .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    // .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    // .matches(/[0-9]/, "Password must contain at least one digit")
    // .matches(
    //   /[!@#$%^&*(),.?":{}|<>]/,
    //   "Password must contain at least one special character"
    // ),
  }),

  "/training/add": yup.object({
    name: yup.string().required("Training name is a required").trim(),
    cover_img: yup.string().required("Upload this field is required").trim(),
    description: yup
      .string()
      .required("Description this field is required")
      .trim(),
    closeDate: yup.string().required("Upload this field is required").trim(),
  }),

  "/quiz/detail": yup.object({
    question: yup.string().required("Question is required").trim(),
  }),

  "/content-add": yup.object({
    contentDropdowns: yup.string().required("Training name is required").trim(),
  }),

  "/people/add": yup.object({
    first_name: yup.string().required("First Name is required").trim(),
    last_name: yup.string().required("Last Name is required").trim(),
    designation: yup.string().required("Designation is required").trim(),
    emp_code: yup
      .string()
      .required("Employee Code is required")
      .min(3, "Employee code must contain atleast 3 characters")
      .max(9, "Employee Code must not exceed 9 characters")
      .trim()
      .matches(/^[^-\s]+$/, "Employee Code cannot contain hyphens"),
    email: yup.string().email("Invalid Email").required("Email is required"),
    mobileNo: yup
      .string()
      .min(10, "Phone number must be minimum 10 digits")
      .max(12, "Phone number must be maximum 12 digits")
      .required("Phone number is required"),
    dob: yup.string().required("Choose Date of Birth"),
    city: yup.string().required("Enter city"),
    status: yup
      .number()
      .required("Status is required")
      .oneOf([0, 1], "Status must be either 0 or 1"),
    Close_Date: yup.string().required("Close date is required"),
    //  .test('is-greater-than-today', 'Close date must be today or later', isDateGreaterOrEqualToday)
  }),
  "/people/edit": yup.object({
    first_name: yup.string().required("First Name is required").trim(),
    last_name: yup.string().required("Last Name is required").trim(),
    designation: yup.string().required("Designation is required").trim(),
    emp_code: yup.string().required("Employee Code is required").trim(),
    email: yup.string().email("Invalid Email").required("Email is required"),
    mobileNo: yup
      .string()
      .required("Phone number is required")
      .min(10, "Phone number must be minimum 10 digits")
      .max(12, "Phone number must be maximum 12 digits"),
    dob: yup.string().required("Choose Date of Birth"),
    city: yup.string().required("Enter city"),
    status: yup
      .number()
      .required("Status is required")
      .oneOf([0, 1], "Status must be either 0 or 1"),
    Close_Date: yup.string().required("Close date is required"),
    // .test('is-greater-than-today', 'Close date must be today or later', isDateGreaterOrEqualToday)
  }),

  "/group/create": yup.object({
    name: yup.string().required("Group Name is required").trim(),
  }),
  "/group/edit": yup.object({
    name: yup.string().required("Group Name is required").trim(),
  }),

  "/quiz": yup.object({
    folderName: yup.string().required("Folder Name is required.").trim(),
    photo: yup.string().required("Image is required.").trim(),
    description: yup.string().required("Description is required.").trim(),
  }),
  "/photo-challenge": yup.object({
    folderName: yup.string().required("Folder Name is required.").trim(),
    title: yup.string().required("Title is required.").trim(),
    description: yup.string().required("Description is required.").trim(),
  }),
  "/video-challenge": yup.object({
    folderName: yup.string().required("Folder Name is required.").trim(),
    title: yup.string().required("Title is required.").trim(),
    description: yup.string().required("Description is required.").trim(),
  }),
  "/zigsaw-challenge": yup.object({
    folderName: yup.string().required("Folder Name is required.").trim(),
    title: yup.string().required("Title is required.").trim(),
    description: yup.string().required("Description is required.").trim(),
  }),
  "/kahoot-quiz": yup.object({
    folderName: yup.string().required("Folder Name is required.").trim(),
    title: yup.string().required("Title is required.").trim(),
    description: yup.string().required("Description is required.").trim(),
    Url: yup
      .string()
      .required("Url is required.")
      .matches(urlRegex, "Enter a valid URL"),
    photo: yup.string().required("Upload a Photo."),
  }),
  "/zooms": yup.object({
    folderName: yup.string().required("Folder Name is required.").trim(),
    title: yup.string().required("Title is required.").trim(),
    description: yup.string().required("Description is required.").trim(),
    Url: yup
      .string()
      .required("Url is required.")
      .matches(urlRegex, "Enter a valid URL"),
    photo: yup.string().required("Upload a Photo."),
    recording_url: yup.string().url("Invalid URL format."),
  }),
  "/survey/add": yup.object({
    name: yup.string().required("Enter Survey Name"),
    surveyType: yup
      .string()
      .required("Survey Type is required")
      .oneOf(["Url", "Quiz"], "Survey Type must be either URL or Quiz"),
    url: yup
      .string()
      .required("URL is required")
      .matches(urlRegex, "Enter a valid URL"),
    description: yup.string().trim().required("Enter Survey Description."),
    closeDate: yup.string().required("Close Date is required"),
  }),
  "/survey/edit": yup.object({
    name: yup.string().required("Enter Survey Name"),
    surveyType: yup
      .string()
      .required("Survey Type is required")
      .oneOf(["Url", "Quiz"], "Survey Type must be either URL or Quiz"),
    url: yup.string().required("URL is required"),
    description: yup.string().trim().required("Enter Survey Description."),
    closeDate: yup.string().required("Close Date is required"),
  }),

  "/add-folder": yup.object({
    Add_Folder: yup
      .string()
      .required("Enter Folder name")
      .min(3, "Folder Name should be minimum 3 characters long")
      .max(50, "Folder Name must not exceed 50 characters"),
  }),

  "/appVersion": yup.object({
    app_version: yup
      .string()
      .required("Enter App Version")
  }),

  "/leaderboard": yup.object({
    point: yup
      .string()
      .required("Enter points")
  }),

  "/leaderboard/changePoint": yup.object({
    point: yup
      .string()
      .required("Enter points")
  })
};


// /**
//  * Utility to match the current route with the schema.
//  * @param {string} pathname - The current URL pathname.
//  * @returns {yup.AnySchema | null} - The validation schema or null if not found.
//  */
// const getValidationSchema = (pathname: string): yup.AnySchema | null => {
//   // Handle dynamic routes like '/quiz/:id' by matching regex for '/quiz/123'
//   if (pathname.match(/^\/quiz\/\d+$/)) {
//     return formSchema["/quiz/:id"];
//   }

//   // Return the corresponding schema for other static paths or null if not found
//   return formSchema[pathname] || null;
// };

// export default getValidationSchema;

